import { render, staticRenderFns } from "./Product1.vue?vue&type=template&id=207d38b1&scoped=true"
import script from "./Product1.vue?vue&type=script&lang=js"
export * from "./Product1.vue?vue&type=script&lang=js"
import style0 from "./Product1.vue?vue&type=style&index=0&id=207d38b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207d38b1",
  null
  
)

export default component.exports